const Notifications = {
  alert: null
};

Notifications.alert = (message) => {
  if (Notifications.toast) {
    Notifications.alert(message);
  }
};
Notifications.setAlert = (alert) => {
  Notifications.alert = alert;
};
export default Notifications;
